import React, { useEffect } from 'react';

function ContactUsRedirectPage() {
  useEffect(() => {
    if (window?.location) {
      const baseUrl = 'https://gemfinance.zendesk.com/hc/en-nz/articles/360010403418-Contact-Us';
      const queryParams = window.location.search;
      const redirectUrl = queryParams ? `${baseUrl}${queryParams}` : baseUrl;

      window.location.replace(redirectUrl);
    }
  }, []);

  return <></>;
}

export default ContactUsRedirectPage;